module.exports = {
	"root": "findify-components-search--lazy-results",
	"next-button": "findify-components-search--lazy-results__next-button",
	"nextButton": "findify-components-search--lazy-results__next-button",
	"prev-button": "findify-components-search--lazy-results__prev-button",
	"prevButton": "findify-components-search--lazy-results__prev-button"
};